"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$ = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$outboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$inboundSchema = void 0;
exports.fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyTypeToJSON = fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyTypeToJSON;
exports.fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyTypeFromJSON = fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyTypeFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const statspropertytype_js_1 = require("./statspropertytype.js");
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$inboundSchema = z.object({
    average_listing_price: z.number().int(),
    property_type: statspropertytype_js_1.StatsPropertyType$inboundSchema,
    total_properties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "average_listing_price": "averageListingPrice",
        "property_type": "propertyType",
        "total_properties": "totalProperties",
    });
});
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$outboundSchema = z.object({
    averageListingPrice: z.number().int(),
    propertyType: statspropertytype_js_1.StatsPropertyType$outboundSchema,
    totalProperties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        averageListingPrice: "average_listing_price",
        propertyType: "property_type",
        totalProperties: "total_properties",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$;
(function (FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$) {
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$inboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$.inboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$inboundSchema;
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$outboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$.outboundSchema = exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$outboundSchema;
})(FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$ || (exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$ = FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$ = {}));
function fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyTypeToJSON(fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType) {
    return JSON.stringify(exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$outboundSchema
        .parse(fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType));
}
function fastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyTypeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'FastapiKrakenEndpointsStatsModelsLettingsNationalGetAverageListingPriceNationalResponsesListingPriceByPropertyType' from JSON`);
}
//# sourceMappingURL=fastapikrakenendpointsstatsmodelslettingsnationalgetaveragelistingpricenationalresponseslistingpricebypropertytype.js.map